import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SearchRequestDto, SearchResponseDto} from './search.dto';
import {map, Observable} from 'rxjs';
import {Search, SearchRequest} from '../domain/search.model';
import {mapSearch, mapSearchRequest} from './search.mapper';

@Injectable({ providedIn: 'root' })
export class SearchService {
  private readonly http = inject(HttpClient);

  private postSearchDtoResult(request: SearchRequestDto): Observable<SearchResponseDto> {
    if (request.cursor) {
      return this.http.post<SearchResponseDto>(`/api/schematics/${request.country}/${request.language}/search`, { cursor: request.cursor });
    } else {
      return this.http.post<SearchResponseDto>(`/api/schematics/${request.country}/${request.language}/search`, {
        q: request.query,
        filters: request.filters
      });
    }
  }

  public search(request: SearchRequest): Observable<Search> {
    return this.postSearchDtoResult(mapSearchRequest(request)).pipe(
      map(mapSearch)
    );
  }
}
